// Portal entry — mounts the Svelte 5 root. Built by apps/server/build.mjs into
// apps/server/dist/portal/app.js and served by the Fastify server at /portal.
import { mount } from "svelte";
import App from "./App.svelte";
import { initTheme } from "@price-check/ui";

// Resolve + apply the saved (or system) theme BEFORE first paint to avoid a flash.
initTheme();

const target = document.getElementById("app");
if (target) mount(App, { target });
